import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { api } from './api.js';
import { AuditLogLoader } from './components/audit-log.js';
import { pageStyles } from './components/cssstyles.js';
import { platformUrl } from './platformUrl.js';
import { RouteConfig } from './router.js';
import { tasks } from './tasks.js';

@customElement('page-administration-audit')
export class PageAdministrationAudit extends LitElement {
  static routes(): RouteConfig[] {
    return [{
      path: [
        '/administration/audit',
      ],
      render: () => html`<page-administration-audit></page-administration-audit>`,
    }];
  }

  static url(): string {
    return platformUrl('/administration/audit');
  }

  private _loader: AuditLogLoader = async (pageOptions, signal) => {
    return await api.administration.auditLog.GET({
      page: pageOptions.number,
      pageSize: pageOptions.size,
    }, { signal });
  };

  private _pageMetadataTask = tasks.pageMetadata(this, {
    args: () => [],
    metadata: () => ({ title: 'Audit Log · Dashboard' }),
  });

  override render() {
    return html`
      <user-header submenu=admin-audit></user-header>
      <app-body wide>
        <h1>Audit log</h1>
        <audit-log .loader=${this._loader}></audit-log>
      </app-body>
    `;
  }

  static styles = [pageStyles];
}
